import {
  Box,
  Card,
  CardContent,
  TextField,
  InputAdornment,
  SvgIcon,
  Button,
  Grid,
  CardHeader,
  Collapse,
  Skeleton,
  Typography,
  FormControlLabel,
  Checkbox,
  Autocomplete,
  ListItem,
  ListItemText,
  ListItemAvatar,
  Avatar,
  Divider,
  Chip
} from '@material-ui/core';
import ArrowDownwardIcon from '@material-ui/icons/ArrowDownward';
import ArrowUpwardIcon from '@material-ui/icons/ArrowUpward';
import AddIcon from '@material-ui/icons/Add';
import { Link as RouterLink } from 'react-router-dom';
import { Search as SearchIcon } from 'react-feather';
import PropTypes from 'prop-types';
import { useSelector, useDispatch } from 'react-redux';
import { setParam } from '../../store/ducks/param';

const UsuarioListToolbar = ({ search, setSearch, query, ...rest }) => {
  const dispatch = useDispatch();
  const globalParam = useSelector((state) => state.param);
  const auth = useSelector((state) => state.auth);

  return (
    <Box {...rest}>
      <Box sx={{ mt: 3 }}>
        <Card>
          <CardHeader
            sx={{ cursor: 'pointer' }}
            onClick={() => {
              dispatch(
                setParam({
                  ...globalParam,
                  bannerFilterBoxOpenned: !globalParam.bannerFilterBoxOpenned
                })
              );
            }}
            title={<Typography variant="h4">Filtros e Pesquisas</Typography>}
            subheader={
              globalParam.bannerFilterBoxOpenned ? (
                <Typography variant="body1">Clique para recolher</Typography>
              ) : (
                <Typography variant="body1">Clique para expandir</Typography>
              )
            }
            avatar={!globalParam.bannerFilterBoxOpenned ? <ArrowDownwardIcon /> : <ArrowUpwardIcon />}
            action={
              <RouterLink to="/app/usuario">
                <Button size="large" color="primary" variant="contained">
                  <AddIcon />
                  Cadastrar
                </Button>
              </RouterLink>
            }
          />
          <Divider />
          <Collapse in={globalParam.bannerFilterBoxOpenned}>
            <CardContent>
              <Grid container spacing={2} wrap="wrap">
                <Grid item md={10} sm={11} xs={11}>
                  <Box>
                    <TextField
                      fullWidth
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <SvgIcon fontSize="small" color="action">
                              <SearchIcon />
                            </SvgIcon>
                          </InputAdornment>
                        )
                      }}
                      placeholder="Pesquisar"
                      variant="outlined"
                      value={search}
                      onChange={(event) => {
                        setSearch(event.target.value);
                      }}
                      onKeyDown={(e) => {
                        if (e.key === 'Enter') {
                          query.set('search', search);
                        }
                      }}
                      onBlur={(e) => {
                        query.set('search', search);
                      }}
                    />
                  </Box>
                </Grid>
                <Grid item md={2} sm={2} xs={2}>
                  <Button
                    fullWidth
                    variant="outlined"
                    size="large"
                    sx={{ py: 1.7 }}
                    startIcon={<SearchIcon />}
                    onClick={() => {
                      window.location.search = query.toString();
                    }}
                  >
                    Pesquisar
                  </Button>
                </Grid>
              </Grid>
            </CardContent>
          </Collapse>
        </Card>
      </Box>
    </Box>
  );
};

UsuarioListToolbar.propTypes = {
  search: PropTypes.any.isRequired,
  setSearch: PropTypes.func.isRequired,
  query: PropTypes.any.isRequired
};

export default UsuarioListToolbar;
